import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { useNavigate } from "react-router";
import { ROUTE_ENUM, TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

interface RodoResponse {
  status: "success" | "error";
  message: string;
  user?: {
    id: number;
    uuid: string;
    rodoAcceptedAt: string;
  };
}

export function useGetRodoAcceptance(uuid: string) {
  const navigate = useNavigate();

  return useQuery({
    queryKey: ["check-rodo-acceptance", uuid],
    queryFn: async () => {
      try {
        const response = await axiosInstance.get<RodoResponse>(`/users/check-rodo/${uuid}`);
        if (response.data.status === "success") {
          Toast({
            message: "Sprawdzanie akceptacji RODO...",
            type: TOAST_TYPES_ENUM.LOADING,
            id: "rodo-check",
          });
          Toast({
            message: "RODO zostało już zaakceptowane, możesz się zalogować.",
            type: TOAST_TYPES_ENUM.SUCCESS,
            id: "rodo-check",
          });

          navigate(ROUTE_ENUM.LOGIN);
        }

        return response.data;
      } catch (error) {
        throw error;
      }
    },
    staleTime: 10000,
    enabled: !!uuid,
    retry: 0,
    select: (data: RodoResponse) => data.user,
  });
}
